import BC from '../init';

export default BC.Methods.toggleContent = ($this) => {
    
    const btn = $this.querySelector('.toggle-content');
    const hidden = $this.querySelector('.hidden');

    const toggleMenu = () => {
        hidden.classList.add('active');
    }

    btn.addEventListener('click', toggleMenu);
};
